import {
  Edit,
  SimpleForm,
  TextInput,
  SelectInput,
  BooleanInput,
  required,
  email,
} from 'react-admin';

export const AdminUserEdit = () => (
  <Edit>
    <SimpleForm>
      <TextInput source="username" disabled />
      <TextInput
        source="email"
        validate={[required(), email()]}
        fullWidth
      />
      <SelectInput
        source="role_id"
        label="Role"
        validate={required()}
        choices={[
          { id: 1, name: 'Super Admin' },
          { id: 2, name: 'Admin' },
          { id: 3, name: 'Support' },
          { id: 4, name: 'Viewer' },
        ]}
      />
      <BooleanInput source="is_active" label="Active" />
    </SimpleForm>
  </Edit>
);
